var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "shortkey",
          rawName: "v-shortkey",
          value: { other: ["ctrl", "s"], mac: ["meta", "s"] },
          expression: "{ other: ['ctrl', 's'], mac: ['meta', 's'] }",
        },
      ],
      staticClass: "v-application mx-n3",
      attrs: { id: "question_editor", row: "", wrap: "" },
      on: { shortkey: _vm.saveFromShortcut },
    },
    [
      _c("MathLive"),
      _vm._v(" "),
      _c(
        "multipane",
        { attrs: { layout: "vertical" } },
        [
          _c(
            "div",
            {
              staticClass: "editor d-flex flex-column justify-lg-space-between",
              style: { minWidth: "30%", width: "50%" },
            },
            [
              _c("EditorToolbarComponent"),
              _vm._v(" "),
              _c("EditorComponent", {
                attrs: { "editor-id": "question_ace_editor" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("multipane-resizer"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "preview",
              style: { flexGrow: 1, minWidth: "30%", width: "50%" },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex h-100" },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "h-100",
                      class: {
                        xs8: _vm.isRevisionMode,
                        xs12: _vm.isEditorMode,
                      },
                    },
                    [
                      _c("NavigatorComponent"),
                      _vm._v(" "),
                      _c("PreviewComponent"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isRevisionMode
                    ? _c(
                        "v-flex",
                        { staticClass: "xs4" },
                        [_c("RevisionComponent")],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ComparisonComponent"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }